/* Registro de tenants demo. Uma segunda loja de demonstração
   é só um novo arquivo de dados + uma entrada aqui.

   A loja-demo "koloni-skateshop" tem StoreData real. As demais contas do
   registro de operador (tenant-registry.ts) são resolvidas como lojas
   SINTÉTICAS na impersonação — Koloni Skate Shop reescalada (synthetic-store.ts),
   simplificação de demo registrada em database-schema.md §6. */
import type { StoreData, TenantRef } from "../api/types";
import { KOLONI_SKATESHOP } from "./koloni-skateshop";
import { clearSyntheticStoreCache, syntheticStore } from "./synthetic-store";
import { TENANT_REGISTRY, type TenantRegistryEntry } from "./tenant-registry";

export const DEMO_TENANT: TenantRef = {
  accountId: "acc_demo",
  storeId: "koloni-skateshop",
};

/** Tenant da PERSONA do lead (gate /demo): loja-vitrine sintética escalada ao
 *  faturamento informado. Mesma conta-demo, storeId próprio. */
export const DEMO_LEAD_STORE_ID = "demo-lead";
export const DEMO_LEAD_TENANT: TenantRef = {
  accountId: "acc_demo",
  storeId: DEMO_LEAD_STORE_ID,
};

const STORES: Record<string, StoreData> = {
  "koloni-skateshop": KOLONI_SKATESHOP,
};

/** Persona de demo do lead — mutável em runtime, servida por getStoreData só
 *  enquanto o lead está na demo (mesmo caminho da impersonação do operador).
 *  Vive aqui, não no contrato: é simplificação de demo (database-schema §6). */
let demoPersonaEntry: TenantRegistryEntry | null = null;

/** Registra (ou limpa) a persona do lead e invalida o cache sintético do
 *  storeId — assim trocar de faixa reescala a vitrine. */
export function setDemoPersona(entry: TenantRegistryEntry | null): void {
  demoPersonaEntry = entry;
  clearSyntheticStoreCache(DEMO_LEAD_STORE_ID);
}

/** Monta a entrada sintética do lead a partir do nome da loja + fator de escala.
 *  Campos administrativos são placeholders (a demo do lojista não os usa; a
 *  persona NÃO entra no TENANT_REGISTRY, então não aparece no /admin). */
export function buildDemoPersonaEntry(p: { loja: string; sizeFactor: number }): TenantRegistryEntry {
  return {
    tenant: DEMO_LEAD_TENANT,
    name: p.loja,
    segment: "Loja online",
    planId: "trial",
    status: "trial",
    mrr: 0,
    sizeFactor: p.sizeFactor,
    usersCount: 1,
    createdAt: "2026-06-10",
    trialEndsAt: null,
    lastActivityAt: "2026-06-10T12:00:00-03:00",
    connections: [],
  };
}

export function getStoreData(storeId: string): StoreData {
  const store = STORES[storeId];
  if (store) return store;
  // Persona do lead (demo personalizada) → vitrine sintética escalada.
  if (demoPersonaEntry && storeId === DEMO_LEAD_STORE_ID) return syntheticStore(demoPersonaEntry);
  // Conta do registro de operador → loja sintética (impersonação).
  const meta = TENANT_REGISTRY.find((t) => t.tenant.storeId === storeId);
  if (meta) return syntheticStore(meta);
  throw new Error(`Loja desconhecida: ${storeId}`);
}
